import {FETCH_USER_DATA} from "./index" 

export const setUserData = (payload) => {
    return {
      type: FETCH_USER_DATA,
      payload: payload
    };
  };